import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const partners = [{
  name: "Aethelgard Capital",
  logo: "/img/abstract_1.jpg"
}, {
  name: "Ironwood Labs",
  logo: "/img/abstract_2.jpg"
}, {
  name: "Monolith Systems",
  logo: "/img/abstract_3.jpg"
}, {
  name: "Obsidian Dynamics",
  logo: "/img/abstract_4.jpg"
}, {
  name: "Vanguard Partners",
  logo: "/img/abstract_5.jpg"
}, {
  name: "Kestrel Foundry",
  logo: "/img/abstract_6.jpg"
}, {
  name: "Sovereign Growth",
  logo: "/img/abstract_7.jpg"
}, {
  name: "Beacon Advisory",
  logo: "/img/abstract_8.jpg"
}, {
  name: "Summit Ventures",
  logo: "/img/abstract_9.jpg"
}, {
  name: "Origin Platform",
  logo: "/img/abstract_10.jpg"
}, {
  name: "Foundry Studio",
  logo: "/img/abstract_11.jpg"
}, {
  name: "Cipher Logic",
  logo: "/img/abstract_12.jpg"
}];
export default function OurGlobalPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="22347" id="selected-ventures" className="bg-background py-20 md:py-24 overflow-hidden dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {}
        <div className="flex items-center justify-center gap-4 mb-16">
          <Separator className="flex-1 bg-primary/20 h-px max-w-[100px] sm:max-w-[200px]" />
          <h2 className="text-5xl md:text-8xl font-default font-extralight text-foreground uppercase tracking-[0.15em] text-center whitespace-nowrap">
            Portfolio
          </h2>
          <Separator className="flex-1 bg-primary/20 h-px max-w-[100px] sm:max-w-[200px]" />
        </div>

        {}
        <div ref={ref} className={cn("grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 md:gap-12 items-center justify-items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {partners.map((partner, i) => <div key={i} data-index={i} className="group w-full flex items-center justify-center p-0">
              <img src={partner.logo} alt={`${partner.name} - Architectural Visual`} className="w-full aspect-[3/4] object-cover filter grayscale opacity-40 transition-all duration-700 ease-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:sepia group-hover:hue-rotate-[15deg] group-hover:scale-[1.02] border border-white/5" loading="lazy" />
            </div>)}
        </div>
      </div>
    </section>;
}